import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './AccordanceDetail.scss';
import AccordanceDetailInfo from '../../../ProjectDetail/ProjectTabs/Accordances/AccordanceDetailInfo/AccordanceDetailInfo';
import CloseCrossButton from '../../Buttons/CloseCrossButton/CloseCrossButton';
import { approveAccordance, draftToApproval, rejectAccordance } from '../../../../api/accordanceApi';
import NewAccordanceForm from '../../../ProjectDetail/ProjectTabs/Accordances/NewAccordanceForm/NewAccordanceForm';
import ErrorMessage from '../../ErrorMessage/ErrorMessage';
import { getIdFromUrl } from '../../../../services/numberUtil';
import { validInputs } from '../../../ProjectDetail/ProjectTabs/Accordances/NewAccordanceForm/NewAccordanceFormUtil';
import { getProjectAccordances } from '../../../../redux/actions/currentProject';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import FooterButtons from './FooterButtons';
import { AccordanceType } from '../../../../models/AccordanceType';
import ConfirmDelete from '../ConfirmDelete/ConfirmDelete';
import { RolesIdEnum } from '../../../../models/RolesIdEnum';
import User from '../../../../models/User';
import {
  ERROR_UNSAVED_ACCORDANCE,
  SUCESSFUL_APPROVED_ACCORDANCE,
  SUCESSFUL_REJECTED_ACCORDANCE,
  SUCESSFUL_SEND_FOR_APPROVAL_ACCORDANCE,
} from '../../../Projects/ProjectsReport/utils/Constants/AlertStatusConstants';

type Props = {
  isOpen: boolean;
  closeModal: any;
  accordance: any;
  showJustificationModal: Function;
  onApproveHandler: Function;
  showConfirmDelete?: Function;
  changeAccordanceStatus: any;
  fromRevision?: boolean;
  role?: number;
  closeShowRelated?: Function;
  onNewValue: Function;
  onNewExpirationDateValue: Function;
  OnNewResponsibleValue: Function;
  hideEdit?: boolean;
  // accordance: any;
  newValue: any;
  submitAccordance: any;
  setLoading: Function;
  setAlertConfig?: Function;
};

const SingleAccordance = (props: Props) => {
  const {
    isOpen,
    closeModal,
    accordance,
    showJustificationModal,
    onApproveHandler,
    showConfirmDelete,
    changeAccordanceStatus,
    fromRevision,
    closeShowRelated = () => { },
    onNewValue,
    onNewExpirationDateValue,
    OnNewResponsibleValue,
    hideEdit,
    role,
    newValue,
    submitAccordance,
    setLoading,
    setAlertConfig,
  } = props;

  const { accordanceState } = accordance;
  const isDraftValid = validInputs(
    accordance?.criticalIssue,
    accordance?.personInCharge,
    accordance?.expirationDate,
    accordance?.revisionDate,
    accordance?.accordanceType,
    accordance?.accordanceAgreementsType,
    accordance?.linkedProductsAccordance,
    accordance?.rootCauseCategory,
    accordance?.rootCause,
    accordance?.criticalIssueDescription,
    accordance?.description,
    accordance?.accordancesSubstantialFundamentalChanges,
    decodeURIComponent(accordance?.urlPMB || ''),
  );

  const accordanceStateNames = {
    0: 'draft_accordance',
    1: 'pending_accordance_singular',
    2: 'active_accordance_singular',
    3: 'accomplished_accordance_singular',
    4: 'cancelled_accordance_singular',
    5: 'rejected'
  };

  const { t } = useTranslation();
  const [editForm, setEditForm] = React.useState(false);
  const [errorsMessage, setErrorsMesssge] = React.useState(false);

  const yearApplied = useSelector<any, any>(state => state.currentProject.accordancesData.selectedYear);
  const accordanceTypeApplied = useSelector<any, any>(state => state.currentProject.accordancesData.selecetdType);
  const user = useSelector<any, User>(state => state.user);

  const [hideApproveButtons, setHideApproveButtons] = React.useState(false);

  const [confirmedModifiedSustantial, setConfirmedModifiedSustantial] = useState<boolean | null>(null);
  const [proceedModification, setProceedModification] = useState<boolean | null>(null);
  const [countTextArea, setCountTextArea] = useState(0);
  const [rejectionJustification, setRejectionJustification] = useState('');
  const [showCloseWithoutSaveConfirm, setShowCloseWithoutSaveConfirm] = useState(false);
  const [isAccordanceFormDirty, setIsAccordanceFormDirty] = useState(false);
  const saveChangesHandlerRef = useRef<(() => void | Promise<void>) | null>(null);

  const isSubstantialModification = accordance?.accordanceAgreementsType?.id === AccordanceType.Substantial;
  const generalRole = role ?? (user?.userId ? user.role.id : undefined);

  // Team creater roles
  const allowedEditRoles = [
    RolesIdEnum.Team_Leader,
    RolesIdEnum.Chief_of_Operations,
    RolesIdEnum.Operations_Analyst,
  ];
  const canCreateOrEditAccordance = Boolean(accordance.currentUserCanEdit) && allowedEditRoles.includes(generalRole!);

  //DivisionChief
  const divChiefRole = generalRole === RolesIdEnum.DivChief;
  const approvedByDivisionChief = accordance.pendingApprovalDivisionChiefOrOne;

  //Country Representative
  const countryRepRole = generalRole === RolesIdEnum.Country_Representative;
  const approvedByCountryRepresentative = accordance.pendingApprovalCountryRepresentativeOrTwo;

  //VPS Managers
  const vps_managers = generalRole === RolesIdEnum.GeneralManagerVPS;
  const approvedByVPSManager = accordance.pendingApprovalVPSManagerOrThree;

  //VPC Managers
  const vpc_managers = generalRole === RolesIdEnum.General_Manager;
  const approvedByVPCManager = accordance.pendingApprovalVPCManagerOrFour;

  const approveAcc = async () => {
    try {
      setLoading(true);
      await approveAccordance(accordance.id);
      onApproveHandler();
      setAlertConfig?.(SUCESSFUL_APPROVED_ACCORDANCE);
      closeModal({ refreshData: true });
    } catch (error) {
      setAlertConfig?.(ERROR_UNSAVED_ACCORDANCE);
      setLoading(false);
    }
  };

  const rejectAcc = async (justification?: string) => {
    const trimmedJustification = typeof justification === 'string' ? justification.trim() : '';

    if (trimmedJustification) {
      try {
        setLoading(true);
        await rejectAccordance(accordance.id, trimmedJustification);
        onApproveHandler();
        setAlertConfig?.(SUCESSFUL_REJECTED_ACCORDANCE);
        closeModal({ refreshData: true });
      } catch (error) {
        setAlertConfig?.(ERROR_UNSAVED_ACCORDANCE);
        setLoading(false);
      }
      return;
    }

    showJustificationModal();
  };

  const deleteAcc = async () => {
    setLoading(true);
    closeModal();
    if (showConfirmDelete) {
      showConfirmDelete();
    }
  };

  React.useEffect(() => {
    if (!isOpen) {
      saveChangesHandlerRef.current = null;
      setEditForm(false);
      setErrorsMesssge(false);
      setConfirmedModifiedSustantial(null);
      setProceedModification(null);
      setCountTextArea(0);
      setRejectionJustification('');
      setShowCloseWithoutSaveConfirm(false);
      setIsAccordanceFormDirty(false);
    }
  }, [isOpen]);

  const accWasEdited = (value: boolean) => {
    onNewValue(value);
    if (value) {
      setHideApproveButtons(true);
    } else {
      setHideApproveButtons(false);
    }
  };

  const dispatch = useDispatch();
  const history = useHistory();

  const submitDraftToApproval = async () => {
    try {
      setLoading(true);
      await draftToApproval(accordance.id);
      dispatch(getProjectAccordances(getIdFromUrl(history.location.search), yearApplied, accordanceTypeApplied));
      setAlertConfig?.(SUCESSFUL_SEND_FOR_APPROVAL_ACCORDANCE);
      props.closeModal({ refreshData: true });
    } catch (error) {
      setAlertConfig?.(ERROR_UNSAVED_ACCORDANCE);
      setLoading(false);
    }
  };

  const colorText = () => {
    switch (accordance.accordanceState) {
      case 1:
        return 'pendding';
      case 3:
        return 'compliment';
      case 5:
        return 'reject';
      default:
        return 'current';
    }
  };

  const hasPendingDecisionChanges = confirmedModifiedSustantial !== null || proceedModification !== null || countTextArea > 0;
  const hasUnsavedChanges = isAccordanceFormDirty || hideApproveButtons || hasPendingDecisionChanges;

  const requestCloseModal = () => {
    if (hasUnsavedChanges) {
      setShowCloseWithoutSaveConfirm(true);
      return;
    }
    closeModal();
  };

  const confirmCloseWithoutSaving = () => {
    setShowCloseWithoutSaveConfirm(false);
    closeModal();
  };

  const closeCloseWithoutSaveConfirm = () => {
    setShowCloseWithoutSaveConfirm(false);
  };


  return (
    <>
      <div className="modal-accordance-detail-container">

        <div className="accordance-header-container">  {/* TOD: Create special component for this div */}
          <div className="accordance-header-container-info">
            <div className="accordance-header-top-row">
              <div>
                <div className="accordance-header-title-row">
                  <h3>{t('accordance_detail').toUpperCase()}{' '}</h3>
                  <p className={colorText()}>{t(accordanceStateNames[accordanceState])}</p>
                </div>
                <p>
                  <b>{accordance.project.code}</b> {t('LON_table')}: {accordance.project.loanNumber}
                </p>
              </div>
              <div className="accordance-header-close-button-wrapper">
                <CloseCrossButton handleClick={requestCloseModal} />
              </div>
            </div>
          </div>
          <div className="accordance-header-container-buttons">
          </div>
        </div>

        {errorsMessage && (
          <ErrorMessage
            customStyle={{ position: 'relative', left: -44, width: 622 }}
            alertMessage={t('could_not_edit_accordance')}
            descriptionMessage={t('please_check_required_fields')}
          />
        )}
        {editForm ? (
          <NewAccordanceForm
            displayGenericErrorsMessage={value => setErrorsMesssge(value)}
            close={closeModal}
            editAccordanceData={accordance}
            accordanceFormType={accordance.accordanceType}
            currentUserCanApprove={accordance.currentUserCanApprove}
            setAlertConfig={setAlertConfig}
            saveChangesHandlerRef={saveChangesHandlerRef}
            submitDraftToApproval={submitDraftToApproval}
            onDirtyChange={setIsAccordanceFormDirty}
            accordanceState={accordanceState}
          />
        ) : (
          <AccordanceDetailInfo
            accordance={accordance}
            isDraftValid={isDraftValid}
            isSubstantialModification={isSubstantialModification}
            changeStatus={value => {
              changeAccordanceStatus(value);
            }}
            fromRevision={fromRevision}
            close={closeShowRelated}
            onNewValue={value => {
              accWasEdited(value);
            }}
            onNewExpirationDateValue={onNewExpirationDateValue}
            OnNewResponsibleValue={OnNewResponsibleValue}
            newValue={newValue}
            submitAccordance={submitAccordance}
            onConfirmedModifiedSustantialChange={value => setConfirmedModifiedSustantial(value)}
            onProceedModificationChange={value => setProceedModification(value)}
            onCountTextAreaChange={value => setCountTextArea(value)}
            onRejectionJustificationChange={value => setRejectionJustification(value)}
            divChiefRole={divChiefRole}
            countryRepRole={countryRepRole}
            approvedByDivisionChief={approvedByDivisionChief}
            approvedByCountryRepresentative={approvedByCountryRepresentative}
            vps_managers={vps_managers}
            vpc_managers={vpc_managers}
            approvedByVPSManager={approvedByVPSManager}
            approvedByVPCManager={approvedByVPCManager}
          />
        )}
      </div>
      <div className="button-footer">
        {!editForm && accordance ? (
          <FooterButtons
            accordance={accordance}
            isDraftValid={isDraftValid}
            approveAcc={approveAcc}
            rejectAcc={rejectAcc}
            deleteAcc={deleteAcc}
            setEditForm={setEditForm}
            submitDraftToApproval={submitDraftToApproval}
            closeModal={requestCloseModal}
            changeAccordanceStatus={changeAccordanceStatus}
            hideApproveButtons={hideApproveButtons}
            isSubstantialModification={isSubstantialModification}
            confirmedModifiedSustantial={confirmedModifiedSustantial}
            proceedModification={proceedModification}
            countTextArea={countTextArea}
            rejectionJustification={rejectionJustification}
            divChiefRole={divChiefRole}
            countryRepRole={countryRepRole}
            approvedByDivisionChief={approvedByDivisionChief}
            approvedByCountryRepresentative={approvedByCountryRepresentative}
            vps_managers={vps_managers}
            vpc_managers={vpc_managers}
            approvedByVPSManager={approvedByVPSManager}
            approvedByVPCManager={approvedByVPCManager}
            canCreateOrEditAccordance={canCreateOrEditAccordance}
          />
        ) : null}
      </div>
      <ConfirmDelete
        isOpen={showCloseWithoutSaveConfirm}
        closeModal={confirmCloseWithoutSaving}
        submit={closeCloseWithoutSaveConfirm}
        customTitle={t('close_without_saving_question')}
        customMessage={t('close_without_saving_description')}
        submitButtonText={t('continue_editing')}
        cancelButtonText={t('close_without_saving')}
      />
    </>
  );
};

export default SingleAccordance;
